import * as React from 'react';
import { Paragraph3, Header4 } from '@cian/ui-kit';
import { Agency24 } from '@cian/ui-kit/icons';

import * as styles from './Author.css';

interface IAuthorProps {
  contactsButton?: React.ReactNode;
  label: string;
  logoUrl?: string | null;
  name: string;
}

export const Author = ({ name, logoUrl, label, contactsButton }: IAuthorProps) => {
  return (
    <div className={styles['footer']}>
      <div className={styles['logo']}>
        {logoUrl ? (
          <img className={styles['logo-image']} src={logoUrl} alt="" />
        ) : (
          <div className={styles['logo-icon']}>
            <Agency24 />
          </div>
        )}
      </div>
      <div className={styles['description']}>
        <Paragraph3 color="gray60_100">{label}</Paragraph3>
        <Header4>{name}</Header4>
      </div>
      {contactsButton && <div className={styles['button']}>{contactsButton}</div>}
    </div>
  );
};
